(() => {
  const normalize = (value) => (value || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

  const initLogo = (image, observer) => {
    const media = image.closest('.freve-brand-card__media');
    if (!media || image.dataset.freveLogoReady === 'true') return;
    image.dataset.freveLogoReady = 'true';

    let triedSecondary = false;

    const showLogo = () => {
      if (image.naturalWidth > 0) {
        media.classList.add('has-logo');
        media.classList.remove('is-loading');
      }
    };

    const hideLogo = () => {
      media.classList.remove('has-logo', 'is-loading');
    };

    const onError = () => {
      const secondary = image.dataset.srcSecondary;
      if (!triedSecondary && secondary && image.src !== secondary) {
        triedSecondary = true;
        media.classList.add('is-loading');
        image.src = secondary;
        return;
      }
      hideLogo();
    };

    image.addEventListener('load', showLogo);
    image.addEventListener('error', onError);

    const load = () => {
      const src = image.dataset.src;
      if (!src || image.src) return;
      media.classList.add('is-loading');
      image.src = src;
      image.removeAttribute('data-src');
    };

    if (image.getAttribute('src')) {
      if (image.complete) {
        image.naturalWidth > 0 ? showLogo() : onError();
      }
      return;
    }

    if (observer) {
      observer.observe(image);
    } else {
      load();
    }

    image._freveLoadLogo = load;
  };

  const init = (root) => {
    if (!root || root.dataset.freveBrandsReady === 'true') return;
    root.dataset.freveBrandsReady = 'true';

    const cards = Array.from(root.querySelectorAll('[data-freve-brand-card]'));
    const search = root.querySelector('[data-freve-brand-search]');
    const clear = root.querySelector('[data-freve-brand-clear]');
    const letters = Array.from(root.querySelectorAll('[data-freve-brand-letter]'));
    const summary = root.querySelector('[data-freve-brand-summary]');
    const empty = root.querySelector('[data-freve-brand-empty]');

    const logoObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const image = entry.target;
            if (typeof image._freveLoadLogo === 'function') image._freveLoadLogo();
            observer.unobserve(image);
          });
        }, { rootMargin: '500px 0px' })
      : null;

    root.querySelectorAll('[data-freve-brand-logo]').forEach((image) => initLogo(image, logoObserver));

    let activeLetter = 'all';

    const applyFilters = () => {
      const query = normalize(search ? search.value : '');
      let visible = 0;

      cards.forEach((card) => {
        const name = normalize(card.dataset.brandName);
        const letter = normalize(card.dataset.brandLetter);
        const matchesQuery = !query || name.includes(query);
        const matchesLetter = activeLetter === 'all' || letter === normalize(activeLetter);
        const show = matchesQuery && matchesLetter;

        card.hidden = !show;
        if (show) visible += 1;
      });

      if (clear) clear.classList.toggle('is-visible', Boolean(query));
      if (summary) {
        const singular = summary.dataset.singular || 'brand';
        const plural = summary.dataset.plural || 'branduri';
        summary.textContent = `${visible} ${visible === 1 ? singular : plural}`;
      }
      if (empty) empty.classList.toggle('is-visible', visible === 0);
    };

    if (search) search.addEventListener('input', applyFilters);

    if (clear) {
      clear.addEventListener('click', () => {
        if (!search) return;
        search.value = '';
        search.focus();
        applyFilters();
      });
    }

    letters.forEach((button) => {
      button.addEventListener('click', () => {
        activeLetter = button.dataset.freveBrandLetter || 'all';
        letters.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        applyFilters();
      });
    });

    applyFilters();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-freve-brands]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
